export default __webpack_public_path__ + "static/media/userId.04e6bc38.png";